module.exports = __webpack_public_path__ + "static/fonts/SFProDisplay-Light.2cd7317.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/fonts/SFProDisplay-Light/SFProDisplay-Light.ttf
// module id = 5LMQ
// module chunks = 16